import UIButtonGroup from 'UIComponents/button/UIButtonGroup';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
export default function Toolbar(props) {
  return /*#__PURE__*/_jsx(UIButtonGroup, Object.assign({
    orientation: "vertical"
  }, props));
}